module.exports = __webpack_public_path__ + "static/media/blog-thumb1.6106fa43.webp";